import React, { type FC } from 'react'

interface IProps {
  label: IQuestion['label']
  index: number
}

const Question: FC<IProps> = ({ label, index }) => {
  return (
    <div className='flex flex-col items-center gap-4'>
      <h2 className='text-sm uppercase underline underline-offset-8 lg:text-lg'>question {index + 1}</h2>
      <p className='text-xl text-center lg:text-3xl'>{label}</p>
      <span className='w-12 h-[1px] bg-duskBlack'></span>
    </div>
  )
}

export default Question
